export const saveState = (key, state) => {
    localStorage.setItem(key, JSON.stringify(state));
};

export const loadState = (key) => {
    const saved = localStorage.getItem(key);
    return saved ? JSON.parse(saved) : null;
};